import { Role } from './constants';
import { user } from './store';
import moment from 'moment';


export const AppFactory = {
  getNewResident: () => {
    return {
      resident_id: undefined,
      role: Role.RESIDENT,
      account_id: user.id,
      first_name: "",
      last_name: "",
      email_1: "",
      email_2: "",
      phone_1: "",
      phone_2: "",
      home_phone: "",
      ubmax_acc: "",
      house_number: "",
      street: "",
      city: "",
      state: "",
      postal_code: "",
      property_type: "",
      route: "",
      division: "",
      well: ""
    }
  },

  getNewAccount: () => {
    return {
      id: "",
      address: "",
      alert_email: "",
      role: Role.USER,
      alert_voice: "MALE1",
      city: "",
      last_name: "",
      password: "",
      phone: "",
      alert_phone: "",
      company: "",
      state: "",
      postal_code: "",
      first_name: "",
      email: "",
      included_alerts: 0,
      last_reset: new Date(),
      created: new Date(),
    }
  }
}

export const addRemainingAlerts = (accountAlerts) => {
  return accountAlerts
    .map(account => {
      return {
        ...account,
        remainingAlerts: account.included_alerts - (account.alertCount.sms + account.alertCount.voice + account.alertCount.email) 
      }
    });
}

export const stitchAlertsWithAccount = (accountResults) => {
  // results => [ {account_id: '123', account_name: 'test', included_alerts: 5000, last_reset: '2020-10-15', alerts: [{alert}, {alert}], [{alert}, {alert}]}, [{alert}, {alert}]]
  const totalsByAccount = accountResults
    .map(account => {
      const accountAlertTotals = account.alerts
        .reduce((alertCounts, alert) => {
          alertCounts['sms'] = alert.smsCount + alertCounts['sms'];
          alertCounts['voice'] = alert.voiceCount + alertCounts['voice'];
          alertCounts['email'] = alert.emailCount + alertCounts['email'];
          return alertCounts; 
      }, {
        sms: 0,
        voice: 0,
        email: 0
      });

      return {
        account_id: account.account_id,
        account_name: account.company,
        included_alerts: account.included_alerts,
        last_reset: account.last_reset,
        days_until_reset: 365 - moment().diff(moment(account.last_reset), 'days'),
        alertCount: accountAlertTotals
      };
    })
  return totalsByAccount;
}

export const isValidEmail = (email) => {
    const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return email && regex.test(email);
}

export const isValidPhoneNumber = (phoneNumber) => {
  const regex = /^\(?[\d]{3}\)?[\s-]?[\d]{3}[\s-]?[\d]{4}$/;
  return phoneNumber && regex.test(phoneNumber);
}